import _default from './Breadcrumb';
export { _default as default };


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/dist/es/collections/Breadcrumb/index.js
// module id = 1742
// module chunks = 0